"use strict";
var DeferObservable_1 = require('./DeferObservable');
exports.defer = DeferObservable_1.DeferObservable.create;
//# sourceMappingURL=defer.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/defer.js
// module id = ../../../../rxjs/observable/defer.js
// module chunks = 4